import { AppThunk } from '../../../store/rootReducer';
import * as layoutAction from '../../layout/actions/layout.actions';
import { getImage, hasILRImage } from '../utils/ilr.utils';

export const loadILRImage =
  (ecgId: string): AppThunk =>
  async (dispatch) => {
    const image = await getImage(ecgId);
    dispatch(
      layoutAction.update({
        update: { ilrImage: { hasImage: hasILRImage(image), loaded: true } },
      }),
    );
  };
